import { render, staticRenderFns } from "./stockOperateInspection.vue?vue&type=template&id=8ea74fce"
import script from "./stockOperateInspection.vue?vue&type=script&lang=js"
export * from "./stockOperateInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports